// extracted by mini-css-extract-plugin
module.exports = {"about":"styles_about__kkkDh","text":"styles_text__1SKsz","instagram":"styles_instagram__3FvZd"};